import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import I18NextHttpBackend from 'i18next-http-backend';
document.body.classList.add('i18n-loading');
const i18nInitialization = i18n
    .use(I18NextHttpBackend)
    .use(initReactI18next)
    .init({
    supportedLngs: ['nl'],
    fallbackLng: ['nl'],
    debug: false,
    ns: ['common'],
    defaultNS: 'common',
    fallbackNS: ['common'],
    interpolation: {
        escapeValue: false,
    },
    backend: {
        loadPath: '/lang/{{lng}}/{{ns}}.json?v=' + process.env.MIX_CACHE_BREAKER,
    },
    react: {
        useSuspense: false,
    },
});
i18nInitialization.then(() => document.body.classList.remove('i18n-loading'));
